import { create } from 'zustand';

/**
 * Gaveta de navegação (só existe abaixo de 1024px).
 *
 * POR QUE UMA STORE E NÃO `useState` NA TELA: o botão hambúrguer mora na barra
 * superior e a gaveta mora na `Sidebar` — dois componentes irmãos, montados
 * separadamente por CADA UMA das 13 telas (não existe um `Shell` comum). Passar
 * `open`/`onToggle` por prop significaria mudar a assinatura das 13 telas e de
 * todas as barras próprias (o catálogo, por exemplo, tem a sua). Com a store,
 * `Sidebar` e `NavToggle` conversam sem que a tela saiba que existe uma gaveta.
 *
 * Sem persistência de propósito: gaveta aberta é estado de momento, não
 * preferência. Recarregar a página tem de começar fechada.
 */
interface NavState {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

export const useNavStore = create<NavState>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  close: () => set({ open: false }),
}));
